/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'swap': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<path pid="0" _fill="currentColor" d="M10 2.707L7.854 4.854a.5.5 0 11-.708-.708l3-3a.498.498 0 01.708 0l3 3a.5.5 0 01-.708.708L11 2.707v10.777a.508.508 0 01-.5.516.508.508 0 01-.5-.516V2.707zm-5 9.586l2.146-2.147a.5.5 0 01.708.708l-3 3a.498.498 0 01-.708 0l-3-3a.5.5 0 01.708-.708L4 12.293V1.509C4 1.228 4.224 1 4.5 1s.5.228.5.51v10.783z"/>'
  }
})
